import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Card from '../Card'; // New centralized Card component
import './styles.css';

const FootballPredictorCard = ({ 
  team1, 
  team1Id,
  team2, 
  team2Id,
  team1WinProb, 
  team2WinProb, 
  drawProb, 
  avgGoals 
}) => {
  const team1IsFavored = team1WinProb > 0.6;
  const team2IsFavored = team2WinProb > 0.6;

  const renderTooltip = (props, teamName) => (
    <Tooltip className="custom-tooltip" id={`tooltip-${teamName.replace(/\s+/g, '-').toLowerCase()}`} {...props}>
      {teamName}
    </Tooltip>
  );

  return (
    <Card className="football-prediction-card">
      <div className="card-content">
        <div className="teams-container">
          <div className={`team team1 ${team1IsFavored ? 'pulse-favorite' : ''}`}>
            <div className="team-header">
              <div className="team-icon-wrapper">
                  {team1IsFavored && (
                    <div className="green-arrows-container">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <span key={i} className="green-arrow" style={{ animationDelay: `${i * 0.3}s` }}>↑</span>
                      ))}
                    </div>
                  )}

                  <OverlayTrigger
                    placement="top"
                    trigger={['hover', 'focus']}
                    delay={{ show: 0, hide: 0 }}
                    overlay={(props) => renderTooltip(props, team1)}
                  >
                    <span className="tooltip-trigger d-inline-block">
                      <img className="team-icon" src={`https://media.api-sports.io/football/teams/${team1Id}.png`} alt={team1} />
                    </span>
                  </OverlayTrigger>
              </div>
            </div>
          </div>
          
          <div className="vs-container">
            <span className="vs-text">VS</span>
          </div>
          
          <div className={`team team2 ${team2IsFavored ? 'pulse-favorite' : ''}`}>
            <div className="team-header">
                <div className="team-icon-wrapper">
                  <OverlayTrigger
                    placement="top"
                    trigger={['hover', 'focus']}
                    delay={{ show: 0, hide: 0 }}
                    overlay={(props) => renderTooltip(props, team2)}
                  >
                    <span className="tooltip-trigger d-inline-block">
                      <img className="team-icon" src={`https://media.api-sports.io/football/teams/${team2Id}.png`} alt={team2} />
                    </span>
                  </OverlayTrigger>

                  {team2IsFavored && (
                    <div className="green-arrows-container">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <span key={i} className="green-arrow" style={{ animationDelay: `${i * 0.3}s` }}>↑</span>
                      ))}
                    </div>
                  )}

                </div>
            </div>
          </div>
        </div>
        
        <div className="avg-goals">
          <span className="goals-label">⚽ Average Goals:</span>
          <span className="goals-value">{avgGoals}</span>
        </div>
      </div>
    </Card>
  );
};

export default FootballPredictorCard;
